// extracted by mini-css-extract-plugin
module.exports = {"timeImage":"timeImage-24jZv","text":"text-5ZJGM"};